import { render, staticRenderFns } from "./UserFollowings.vue?vue&type=template&id=b96c45a0&scoped=true&"
import script from "./UserFollowings.vue?vue&type=script&lang=js&"
export * from "./UserFollowings.vue?vue&type=script&lang=js&"
import style0 from "./UserFollowings.vue?vue&type=style&index=0&id=b96c45a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96c45a0",
  null
  
)

export default component.exports